module.exports = __webpack_public_path__ + "static/img/img-features-feature-2-game-4.3107697.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/features/img-features-feature-2-game-4.png
// module id = gEon
// module chunks = 18